import React from 'react'

/**
 * 粉丝数
 */
const NumberOfFans = ({
  record,
}) => {
  const valStr = record?.demand_source_kol_content_vo?.follower_num?.toLocaleString?.()
  return <div className='flex justify-end w-full'>
    {valStr || '--'}
  </div>
}

export default NumberOfFans
